$(() => {
  if (!$('.js-single-select-input').length) {
    return;
  }

  let setupComponent = (element) => {
    const formGroup = $(element);
    const radios = formGroup.find('input[type="radio"]');
    const otherRadio = formGroup.find('.js-single-select-input-other');
    const otherTextField = formGroup.find('.js-single-select-input-other-textfield');
    const hiddenInput = formGroup.find('input[type="hidden"]');

    // 「その他」押下でtext_fieldを開く
    otherRadio.on('change', () => {
      if (otherRadio.is(':checked')) {
        otherTextField.show().focus();
        hiddenInput.val('other_' + otherTextField.val());
      }
    });

    // 「その他」以外を押下でtext_fieldを閉じる
    radios.not(otherRadio).on('change', function () {
      if ($(this).is(':checked')) {
        otherTextField.hide();
        hiddenInput.val($(this).val());
      }
    });

    // 「その他」テキスト入力時にhiddenの値を更新
    otherTextField.on('input', () => {
      if (otherRadio.is(':checked')) {
        // その他のテキストはother_{値}として保存される
        hiddenInput.val('other_' + otherTextField.val());
      }
    });

    // 初期値をセット
    const checkedRadio = radios.filter(':checked');
    if (checkedRadio.length) {
      if (checkedRadio.is(otherRadio)) {
        otherTextField.show();
        hiddenInput.val('other_' + otherTextField.val());
      } else {
        otherTextField.hide();
        hiddenInput.val(checkedRadio.val());
      }
    } else {
      otherTextField.hide();
      hiddenInput.val('');
    }
  };

  $('.js-single-select-input').each((i, element) => {
    setupComponent(element);
  });
});
